import { render, staticRenderFns } from "./FieldWorkplaceMaterialList.vue?vue&type=template&id=1590eaf8&scoped=true"
import script from "./FieldWorkplaceMaterialList.vue?vue&type=script&lang=js"
export * from "./FieldWorkplaceMaterialList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1590eaf8",
  null
  
)

export default component.exports